"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortOrder = void 0;
exports.SortOrder = {
    UNSORTED: 0,
    ASC: 1,
    DESC: 2,
};
//# sourceMappingURL=Enums.js.map